import styled from "styled-components";

const Container = styled.div`
  padding: 20px;
  margin: 0 auto;
  max-width: 800px;
  text-align: center;
`;

export default Container;
